export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10583.83ab6b85.jpg";